// extracted by mini-css-extract-plugin
export var checkbox = "checked-newsletter-module--checkbox--AdWHW";
export var checkmark = "checked-newsletter-module--checkmark--6KdvG";
export var container = "checked-newsletter-module--container--ZJSlf";
export var input = "checked-newsletter-module--input--6mm5K";
export var label = "checked-newsletter-module--label--O+LBt";
export var labelContent = "checked-newsletter-module--label-content--e7t2S";